import { render } from "./CV.vue?vue&type=template&id=71aa155e&scoped=true&lang=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"

import "./CV.vue?vue&type=style&index=0&id=71aa155e&lang=postcss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aa155e"]])

export default __exports__